<template>
	<div>
		<TwoColumn>
			<FieldSelect
				name="campaign"
				label="Campaign"
				:options="campaignOptions"
				v-model="id"
			/>
			<FieldDateRange
				name="range"
				label="Date range"
				v-model="range"
				:default-value="defaultRange"
			/>
		</TwoColumn>
		<div v-if="globalStats" class="stats">
			<p>
				<strong>{{ globalStats.started.value }}</strong>
				{{ globalStats.started.word }} started
			</p>
			<p>
				<strong>{{ globalStats.submitted.value }}</strong>
				{{ globalStats.submitted.word }} completed
			</p>
		</div>
	</div>
</template>

<script>
import pluralize from 'pluralize'
import TwoColumn from '@/components/shared/TwoColumn'
import FieldSelect from '@/components/shared/FieldSelect'
import FieldDateRange from '@/components/shared/FieldDateRange'
import { isSet, unpick } from '../../lib/helpers'

export default {
	name: 'ModerationFiltersForm',
	props: {
		campaigns: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		id: {
			get() {
				const asNum = Number(this.$route.params.id)
				return { value: !isNaN(asNum) ? asNum : null }
			},
			set({ value: id }) {
				if (!isSet(id) || id === this.id.value) return
				const [from, to] = this.resolveCampaignDates(id)
				const query = unpick(this.$route.query, ['_start'])
				this.$router.replace({
					...this.$route,
					params: { id },
					query: { ...query, _from: from, _to: to }
				})
			}
		},
		range: {
			get() {
				const from = this.$route.query._from || null
				const to = this.$route.query._to || null
				return { value: [from, to] }
			},
			set({ value: [from, to] }) {
				if (from === this.range.value[0] && to === this.range.value[1]) return

				const query = unpick(this.$route.query, ['_start'])
				const _from = from || this.defaultRange[0]
				const _to = to || this.defaultRange[1]

				this.$router.replace({
					...this.$route,
					query: { ...query, _from, _to }
				})
			}
		},
		defaultRange() {
			return this.resolveCampaignDates(this.id.value)
		},
		campaign() {
			return this.campaigns.find(campaign => campaign.id === this.id.value)
		},
		campaignOptions() {
			return this.campaigns.map(({ id, name }) => {
				return { value: id, label: name }
			})
		},
		globalStats() {
			if (!this.campaign) return null
			const word = 'total voting session'
			return {
				started: {
					value: this.campaign.sessions.started,
					word: pluralize(word, this.campaign.sessions.started)
				},
				submitted: {
					value: this.campaign.sessions.submitted,
					word: pluralize(word, this.campaign.sessions.submitted)
				}
			}
		}
	},
	methods: {
		resolveCampaignDates(id) {
			const campaign = this.campaigns.find(campaign => campaign.id === id)
			return campaign
				? campaign.dates.map(date => date.replace('Z', '+10:00'))
				: [null, null]
		},
		resetRange() {
			this.range = { value: this.resolveCampaignDates(this.id.value) }
		}
	},
	created() {
		if (isSet(this.id.value) && this.range.value.some(date => !isSet(date))) {
			this.range = { value: this.resolveCampaignDates(this.id.value) }
		}
	},
	components: {
		TwoColumn,
		FieldSelect,
		FieldDateRange
	}
}
</script>

<style lang="scss" scoped>
.stats {
	margin-top: 1.5rem;
	> p {
		margin: 0;
		&:not(:last-child) {
			margin-bottom: 0.25rem;
		}
	}
}
</style>
